import { ContactField } from '../ContactField/ContactField';
import type { ContactFieldConfig } from '../ContactField/ContactField';
import type { ContactsSectionProps } from '../Contacts.types';

const FIELDS: ContactFieldConfig[] = [
  { name: 'email', label: 'Email', type: 'email', isRequired: true },
  { name: 'phone', label: 'Direct phone', type: 'tel', isRequired: true },
  { name: 'firstName', label: 'First name' },
  { name: 'lastName', label: 'Last name' },
  { name: 'position', label: 'Position' },
  { name: 'comment', label: 'Comment', multiline: true },
];

const PARENT = 'guestRelationContact';

export const GuestRelationContact = ({
  isEditMode,
  hideComment = false,
}: ContactsSectionProps) => {
  const fields = hideComment
    ? FIELDS.filter((field) => field.name !== 'comment')
    : FIELDS;

  return (
    <>
      {fields.map((field) => (
        <ContactField
          key={field.name}
          {...field}
          parent={PARENT}
          isEditMode={isEditMode}
        />
      ))}
    </>
  );
};
